import React from 'react';

/**
 * Superficie contenitore: sfondo bianco, angoli arrotondati, bordo.
 *
 * Racchiude SOLO le classi invarianti nei 169 punti del codice che usano
 * questa superficie (bg-white + rounded-2xl + border + border-gray-200).
 *
 * Padding e ombra NON sono inclusi di proposito: nel codice attuale variano
 * (p-4 / p-5 / p-6 / nessuno, shadow-sm / shadow-md) e vanno passati dal
 * chiamante tramite className. Cosi non esiste alcuna classe che il
 * chiamante debba sovrascrivere, e la concatenazione non puo mai produrre
 * conflitti la cui risoluzione dipenderebbe dall'ordine del CSS generato.
 *
 * Per lo stesso motivo className NON deve ridefinire sfondo, raggio o
 * colore del bordo: le 17 superfici con bordo diverso (slate/red/emerald)
 * restano markup nativo.
 *
 * bg-surface = bg-white | rounded-surface = rounded-2xl | border-line = border-gray-200
 */
export default function Card({ className = '', ...props }) {
  return (
    <div
      {...props}
      className={`bg-surface rounded-surface border border-line ${className}`.trim()}
    />
  );
}
